import React from "react";
import { Button, FunctionField, ShowProps, TextField } from "react-admin";
import { Grid, makeStyles, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { GridinRowsWithSpace } from "utils/style";
import CustomDateField from "components/CustomDateField";
import { GetParam } from "utils/tools";
import EditIcon from "@material-ui/icons/Edit";
import InfoIcon from "@material-ui/icons/Info";
import CustomTooltip from "../../components/CustomTooltip";
import CustomLabeled from "../../components/layout/CustomLabeled";

const useStyles = makeStyles({
  summaryButton: {
    position: "relative",
    top: 20,
    padding: "8px 16px",
  },
  captionTooltip: {
    marginTop: "5px",
    marginBottom: "5px",
  },
  captionText: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    gap: "2px",
  },
  labelWrapper: {
    display: "inline",
  },
  infoIcon: {
    verticalAlign: "middle",
    marginLeft: "5px",
  },
});

const Summary = (props: ShowProps) => {
  const param = GetParam();
  const classes = useStyles();

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12} style={GridinRowsWithSpace}>
          <Typography variant="h6">Academic Year Detail</Typography>
          <Button
            className={classes.summaryButton}
            onClick={() =>
              props.history.push(
                `/academicYears/${props.id}?schoolId=${param.get("schoolId")}`
              )
            }
            label="Edit"
          >
            <EditIcon />
          </Button>
        </Grid>

        <Grid item xs={4}>
          <CustomLabeled name="Name">
            <TextField source="name" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Start Date">
            <CustomDateField source="startDate" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="End Date">
            <CustomDateField source="endDate" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Early Registration Start Date">
            <CustomDateField
              source="earlyRegistrationStartDate"
              emptyText="-"
            />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Early Registration End Date">
            <CustomDateField source="earlyRegistrationEndDate" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Late Registration Start Date">
            <CustomDateField source="lateRegistrationStartDate" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}>
          <FunctionField
            addLabel={false}
            render={(record: any) => (
              <CustomLabeled name="Late Registration Minimum Days Offset (Days)">
                <div className={classes.labelWrapper}>
                  <TextField source="lateRegMinDaysOffset" emptyText="14" />
                  <CustomTooltip
                    title={
                      <>
                        <Typography variant="caption">
                          If the Late Registration Minimum Days Offset is set to{" "}
                          {record.lateRegMinDaysOffset || 14}, it means that
                          when a parent registers after the Late Registration
                          Start Date, they can only register for dates at least{" "}
                          {record.lateRegMinDaysOffset || 14} days from the
                          registration date.
                        </Typography>
                      </>
                    }
                    aria-label="Late Registration Minimum Days Offset"
                    classes={{
                      tooltip: classes.captionTooltip,
                    }}
                    placement="bottom-start"
                    component="span"
                  >
                    <InfoIcon
                      fontSize="small"
                      color="secondary"
                      className={classes.infoIcon}
                    />
                  </CustomTooltip>
                </div>
              </CustomLabeled>
            )}
          />
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Refund Rate (%)">
            <TextField source="refundRate" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
